'use strict';


app.factory('TicketedEvent', ['$rootScope', '$http', 'env_config',
    function ($rootScope, $http, env_config) {
        var service = {};

        /**
         * get event details
         * 
         * @param  String    search
         * @param  Integer   pagination
         * @param  Function  callback
         */
        service.get = function (event_slug, callback) {

            $http({
                url: env_config.api_url + 'api/tickets/' + event_slug,
                mehod: 'GET'
            })
                .success(function (resp, status) {
                    callback(resp, status);
                })
                .error(function (resp, status) {
                    callback(resp, status);
                });
        };

        return service;
    }]);